/** Knowledge node types (backend KGNodeType) and the folder new pages of each go in. */
export const NODE_TYPES = ["person", "project", "product", "concept", "document", "event", "company", "agent"] as const;
export type NodeType = (typeof NODE_TYPES)[number];

const FOLDER: Record<NodeType, string> = {
  person: "people",
  project: "projects",
  product: "products",
  concept: "concepts",
  document: "documents",
  event: "events",
  company: "companies",
  agent: "agents",
};

export function isNodeType(value: string | null | undefined): value is NodeType {
  return (NODE_TYPES as readonly string[]).includes(value ?? "");
}

/** "Ada Lovelace" → "ada-lovelace" (accents dropped, like the backend's slugs). */
export function slugify(text: string): string {
  return text
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-") // runs collapse to one "-", so at most one at each end
    .replace(/^-|-$/g, "");
}

/** Where a new page of this type and title goes by default, e.g. `people/ada-lovelace.md`. */
export function defaultPagePath(type: NodeType, title: string): string {
  const slug = slugify(title);
  return slug ? `${FOLDER[type]}/${slug}.md` : "";
}

/**
 * Starting markdown for a new page. New pages are private (editors only) until
 * someone changes `visibility`: knowledge is shared explicitly. The title goes
 * in the heading, not the frontmatter, so no YAML escaping is needed.
 */
export function newPageContent(type: NodeType, title: string): string {
  return `---\ntype: ${type}\nvisibility: private\n---\n# ${title.trim()}\n\n`;
}
